import React, { useMemo } from 'react';

import { ApplyButton } from 'components/Filters';

import { isEqualFilterValues } from '@gogame/filters';
import { useScreenState } from '@gogame/screens';

import useIsValidFilters from './hooks/useIsValidFilters';

const ApplyFiltersButton = ({ tooltip, onClick, dirty, disabled }) => {
  const screenState = useScreenState();

  const filtersDirty = useMemo(() => {
    return (
      screenState.temporary &&
      (screenState.temporary.columns.order.toString() !==
        screenState.columns.order.toString() ||
        !isEqualFilterValues(
          screenState.temporary.filters,
          screenState.filters
        ))
    );
  }, [screenState]);

  const { filters } = screenState.temporary || screenState;

  const validFilters = useIsValidFilters(filters);

  return (
    <ApplyButton
      tooltip={
        tooltip
          ? tooltip
          : !validFilters
            ? 'Make selections in the required filters'
            : undefined
      }
      onClick={onClick}
      disabled={!validFilters || !(filtersDirty || dirty) || disabled}
    />
  );
};

export default ApplyFiltersButton;
